import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import SquareIcon from '@mui/icons-material/Square';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { EditarUsuario } from './EditarUsuario';
import { delUsuario } from '../../../services/apis';
import { advertenciaEliminar } from '../../../utils/componentes-utiles/advertencias';


export const UsuarioCard = ({ usuario, opciones, cargarUsuarios, departamentos, roles, clientes }) => {

    const [openEdit, setOpenEdit] = useState(false);
    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                setOpenEdit(true);
                // Lógica para la opción 1
                break;
            case 2:
                eliminarUsuario(usuario.id);
                // Lógica para la opción 2
                break;

            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }
    const eliminarUsuario = async (id) => {
        const titulo = "Eliminar " + usuario.nombre;
        const texto = "Vas a eliminar permanentemente este usuario";

        // Asegúrate de esperar el resultado de advertenciaEliminar
        const confirmado = await advertenciaEliminar(titulo, texto);
        if (confirmado) {
            try {
                const response = await delUsuario(id);
                if (response.success === true) {
                    cargarUsuarios();
                }
            } catch (error) {
                console.error("Error al eliminar la tarea:", error);
            }
        }

    };
    return (
        // <div className="flex-center">
        <Grid
            container
            xs={12}
            gap={1}
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="fichaje-card fade-in2"
            sx={{ padding: 2, borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)" }}
        >

            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="center"
                xs={12}
                gap={1.5}
            >
                <Grid item xs={2}>
                    <AccountCircleIcon sx={{ fontSize: 40, color: usuario.color }} />
                </Grid>

                <Grid item xs={9}>
                    <Typography variant='h6' className='ellip' sx={{ textAlign: 'left' }}>
                        {usuario.nombre}
                    </Typography>
                </Grid>
            </Grid>

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={12}
            >
                <Typography variant='caption'>
                    <strong>Rol:</strong> {usuario.nombre_rol}
                </Typography>

                <Typography variant='caption'>
                    <strong>Departamento:</strong> {usuario.nombre_departamento}
                </Typography>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={12}
            >
                {opciones && (
                    <OpcionesMenuFunc small={true} variant={"text"} justifyContent={'space-between'} opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
                )}
            </Grid>

            {openEdit && (
                <EditarUsuario
                    open={openEdit}
                    setOpen={setOpenEdit}
                    cargarUsuarios={cargarUsuarios}
                    departamentos={departamentos}
                    roles={roles}
                    clientes={clientes}
                    usuarioData={usuario}
                />
            )}

        </Grid>

        // </div >
    );
};
